<script>
export default {
  props: {
    pending: Boolean,
    naked: Boolean,
    scroll: Boolean,
    stickyAction: Boolean,
    enableSubmit: Boolean,
  },
  methods: {
    prevent: function ($event) {
      if (
        !this.enableSubmit &&
        !$event.target.classList.contains("f-form-allow-enter")
      ) {
        $event.preventDefault();
        return false;
      }
    },
  },
};
</script>

<template>
  <form class="f-form" :class="[{ pending }, { naked }, { scroll }, { stickyAction }]" @submit.prevent
    @keydown.enter="prevent($event)" @keypress.enter="prevent($event)">
    <div class="f-form-pending" v-if="pending">
      <f-loader-circular></f-loader-circular>
    </div>
    <div class="title" v-if="$slots.title">
      <slot name="title"></slot>
    </div>
    <div class="content-container">
      <f-sexy-scroll v-if="scroll">
        <div class="content">
          <slot name="content"></slot>
          <div class="action" v-if="$slots.action && !stickyAction">
            <slot name="action"></slot>
          </div>
        </div>
      </f-sexy-scroll>
      <div class="content" v-if="!scroll">
        <slot name="content"></slot>
        <div class="action" v-if="$slots.action && !stickyAction">
          <slot name="action"></slot>
        </div>
      </div>
      <div v-if="stickyAction && $slots.action" class="sticky-action">
        <slot name="action"></slot>
      </div>
    </div>
  </form>
</template>

<style lang="scss">
.f-form {
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  box-shadow: 0px 4px 16px rgba(22, 22, 21, 0.1);
  border-radius: 8px;
  position: relative;

  .f-form-pending {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
    backdrop-filter: blur(2px);
    background-color: #ffffff61;
    border-radius: 8px;
  }

  >.title {
    color: #161615;
    font-family: Lato;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 17px;
    display: flex;
    gap: 7px;
    align-items: center;
    padding: 20px 20px 0 20px;
  }

  .f-icon {
    // Ils font iech ces 2 proprietes
    // color: #5cbab6;
    // font-size: 18px;
  }

  >.content-container {
    flex: 1 1 100%;
    height: 0;
    display: flex;
    flex-direction: column;
    margin-top: 25px;
    margin-bottom: 34px;

    .f-sexy-scroll {
      flex: 1 1 auto;
    }

    .content {
      display: flex;
      flex-direction: column;
      gap: 16px;
      margin: 0 12px;
      padding: 0 20px 2px 20px;
      flex: 1 1 100%;

      .action {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        padding-top: 0;
        align-items: center;
        justify-content: space-evenly;
      }
    }

    .sticky-action {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      padding-top: 0;
      align-items: center;
      justify-content: space-evenly;
      margin: 12px;
    }
  }

  &.naked {
    background-color: transparent;
    padding: 0;
    box-shadow: none;
    border: none;
    border-radius: unset;

    >.title {
      display: none;
    }

    >.content {
      margin: 0;
    }
  }

  &.stickyAction {
    .content-container {
      margin-bottom: 0;
    }
  }

  &.stickyAction.scroll {
    .f-sexy-scroll {
      flex: 1 1 100%;
    }
  }

  .f-form {
    padding: 0;
    box-shadow: none;
    border: none;
    border-radius: unset;

    >.title {
      text-transform: uppercase;
      color: rgba(22, 22, 21, 0.5);
    }
  }
}

form .f-form-button:hover,
form .f-form-button:focus,
form .f-form-button:active {
  border: 1px solid #1890d3;
  outline: 5px solid rgba(24, 144, 211, 0.25);
}

form .f-form-button {
  margin-top: 8px;
  margin-bottom: 16px;
  border: 1px solid transparent;
}

form {
  .content-container {
    .content {
      >.f-form-field {
        width: 100%;
      }

      .action {
        .f-form-field {
          margin-top: 16px;
          width: 100%;
        }

        .f-button {
          width: 100%;
        }
      }
    }

    .sticky-action {
      .f-button {
        width: 100%;
      }
    }
  }
}

.dark-mode {
  .f-form {
    background-color: var(--black);

    .title {
      color: var(--white-a75);

      >.f-icon {
        font-size: 20px;
        color: var(--primary);
      }
    }
  }
}
</style>